import { getTrackingContext } from './context'

export const reset = ({ resetDevice = false } = {}) => {
  const { setTrackingContextValue, client, ready } = getTrackingContext()
  if (!ready) return
  client.reset(resetDevice)
  setTrackingContextValue(prevTrackingContextValue => ({
    ...prevTrackingContextValue,
    identified: false,
    ready: false,
    reset: true,
  }))
}

// eslint-disable-next-line no-unused-vars
export const capture = (eventName, options = {}) => {
  const { getPendingEventQueue, capturePendingEvents } = getTrackingContext()
  const queue = getPendingEventQueue()

  queue.push(['capture', [eventName, options]])
  capturePendingEvents()
}
